import { render } from "./purchase.vue?vue&type=template&id=e2ffb254&scoped=true"
import script from "./purchase.vue?vue&type=script&lang=js"
export * from "./purchase.vue?vue&type=script&lang=js"

import "./purchase.vue?vue&type=style&index=0&id=e2ffb254&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2ffb254"]])

export default __exports__